import React from "react";
import { DialogActions as MUIDialogActions } from "@mui/material";
import styled from "styled-components";

const StyledMUIDialogActions = styled(MUIDialogActions)``;

export const DialogActions = (props) => {
  return <StyledMUIDialogActions {...props} />;
};
